import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/tubo_cerquero.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import lamina from "../img/Lamina.png";
import silueta from "../img/lamina-silueta.png"

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}>
          Lamina R-101
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto */}
        <div className="col-md-4 d-flex justify-content-center align-items-center" style={{ height: '450px', textAlign: 'justify' }}>
          <br /><br />
          <p style={{ marginLeft: '10px', textAlign: 'justify' }}>
            La lámina R-101 es un perfil acanalado de acero utilizado en la construcción para cubiertas y muros.
            Se caracteriza por su resistencia estructural, facilidad de instalación y capacidad de drenaje. Está
            disponible en diferentes calibres y materiales, como acero galvanizado o pintado, lo que la hace
            ideal para naves industriales, bodegas y techados en general.
            <br /><br />
            <img src={silueta} alt="PTR" style={{ maxWidth: '350px', marginLeft: '30px' }} />
            <br /><br />
            <img src={lamina} alt="PTR" style={{ maxWidth: '400px', marginLeft: '20px' }} />
          </p>
        </div>

        <div className="col-md-8">
          {/* Contenedor con scroll para las tres tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table className="table table-striped" style={{ textAlign: 'center' }}>
              <thead>
                <tr>
                  <th colspan="7" class="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background: '#f58634' }}>
                    Lámina R-101
                  </th>
                </tr>
                <tr>
                  <th rowspan="2" style={{ background: "#ffe4b2", color: "#000" }}>Kg. x mts. L</th>
                  <th rowspan="2" style={{ background: "#ffe4b2", color: "#000" }}>Calibre</th>
                  <th colspan="4" style={{ background: "#ffe4b2", color: "#000" }}>Tipo kg x hoja</th>
                </tr>
                <tr>
                  <th>2.44</th>
                  <th>3.66</th>
                  <th>4.27</th>
                  <th>6.10</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td>7.32</td>
                  <td>22</td>
                  <td>17.860</td>
                  <td>26.800</td>
                  <td>31.600</td>
                  <td>44.650</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>5.87</td>
                  <td>24</td>
                  <td>14.3300</td>
                  <td>21.500</td>
                  <td>25.060</td>
                  <td>38.000</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>4.33</td>
                  <td>26</td>
                  <td>10.560</td>
                  <td>15.850</td>
                  <td>18.490</td>
                  <td>26.413</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3.66</td>
                  <td>28</td>
                  <td>8.930</td>
                  <td>13.395</td>
                  <td>15.630</td>
                  <td>22.330</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>3.23</td>
                  <td>30</td>
                  <td>7.030</td>
                  <td>10.540</td>
                  <td>12.300</td>
                  <td>17.570</td>
                </tr>
              </tbody>
            </table>
            <p>
              <ul style={{marginLeft: "50px"}}>
              <li>Zintro</li>
              <li>Pintro</li>
            </ul>
            </p>
          </div>
        </div>
      </div>
    </section >
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{textDecoration:'none'}}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
              <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Lamina_R101 = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Lamina_R101;
